export default {
    SET_TRANSFER_LISTS: 'setTransferLists',
    CLEAR_TRANSFER_LISTS: 'clearTransferLists',
}
